export type IconKey =
  | 'home'
  | 'drone'
  | 'droneModel'
  | 'campaign'
  | 'user'
  | 'organization'
  | 'preferences'
  | 'deviceType'
  | 'device'
  | 'share';

export interface NavigationLink {
  type: 'link';
  l10nKey: string;
  icon: IconKey;
  to: string;
  permissions?: string[];
}

export interface NavigationSubheader {
  type: 'subheader';
  l10nKey: string;
}

type NavigationItem = NavigationLink | NavigationSubheader;

export const navItems: NavigationItem[] = [
  {
    type: 'link',
    l10nKey: 'navigation.dashboard',
    icon: 'home',
    to: '/dashboard'
  },
  {
    type: 'link',
    l10nKey: 'navigation.devices',
    icon: 'drone',
    to: '/devices'
  },
  {
    type: 'link',
    l10nKey: 'navigation.campaigns',
    icon: 'campaign',
    to: '/campaigns'
  },
  {
    type: 'link',
    l10nKey: 'navigation.crew',
    icon: 'share',
    to: '/crew'
  },
  {
    type: 'link',
    l10nKey: 'navigation.users_permissions',
    icon: 'user',
    to: '/user-permissions'
  },
  {
    type: 'subheader',
    l10nKey: 'navigation.settings_header'
  },
  {
    type: 'link',
    l10nKey: 'navigation.organization_settings',
    icon: 'organization',
    to: '/organization-settings'
  },
  {
    type: 'link',
    l10nKey: 'navigation.account_preferences',
    icon: 'preferences',
    to: '/account-preferences'
  },
  {
    type: 'subheader',
    l10nKey: 'navigation.admin_tools'
  },
  {
    type: 'link',
    l10nKey: 'navigation.mission_manager',
    icon: 'campaign',
    to: '/pilot/mission-manager'
  },
  {
    type: 'link',
    l10nKey: 'navigation.system_device_types',
    icon: 'deviceType',
    to: '/device-types',
    permissions: ['view_list_device_types']
  },
  {
    type: 'link',
    l10nKey: 'navigation.system_devices',
    icon: 'device',
    to: '/system-devices',
    permissions: ['view_all_devices']
  }
];
